import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79354e0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bridge-container" }
const _hoisted_2 = { class: "bridge-content" }


const __default__ = {
  name:'CBridge'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    count: null
  },
  setup(__props: any) {

const props = __props as {
  count: number
};



return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_svg_icon, {
        class: "svgi",
        icon: "bell",
        style: {"font-size":"24px"}
      })
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.count), 1)
  ]))
}
}

})